(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vac-collection-manufacturers"] && !Shopify.designMode) return;
  try {
    
(()=>{document.querySelectorAll('[data-sq-maker-browser]').forEach(root=>{if(root.dataset.ready==='true')return;root.dataset.ready='true';const input=root.querySelector('[data-sq-maker-search]'),cards=[...root.querySelectorAll('[data-sq-maker-card]')],count=root.querySelector('[data-sq-maker-count]'),empty=root.querySelector('[data-sq-maker-empty]');if(!input)return;input.addEventListener('input',()=>{const term=input.value.trim().toLowerCase();let visible=0;cards.forEach(card=>{const match=!term||(card.dataset.maker||'').toLowerCase().includes(term);card.hidden=!match;if(match)visible++});if(count)count.textContent=`${visible} manufacturer${visible===1?'':'s'}`;if(empty)empty.hidden=visible!==0})})})();

  } catch(e) { console.error(e); }
})();
})();
